var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { MainCore } from '@core-front/main';
import { getBackgroundColorClass } from '@telia-front/colors';
import CookieConsentProvider from '@telia-front/cookie-consent-provider';
import HeaderProvider from '@telia-front/header-provider';
import InputProvider from '@telia-front/input-provider';
const Main = (props) => {
    const { background, className } = props, rest = __rest(props, ["background", "className"]);
    const BEM = () => {
        const classArray = [];
        if (background) {
            classArray.push(getBackgroundColorClass(background));
        }
        if (className) {
            classArray.push(className);
        }
        return classArray.join(' ');
    };
    return (React.createElement(MainCore, Object.assign({}, rest, { className: BEM(), components: {
            InputProvider,
            CookieConsentProvider,
            HeaderProvider,
        } })));
};
export { Main as default };
